"use strict";function externalComplexPicker$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.externalComplexPicker$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.contact.externalComplexPicker";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"3.0.0"},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.0"},_a)),exports.externalComplexPicker$=externalComplexPicker$,exports.default=externalComplexPicker$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/contact/externalComplexPicker.js
// module id = 934
// module chunks = 106